import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Toggle as MarvelToggle } from '@marvelapp/ui';
export function Toggle(_a) {
    var { disabled } = _a, props = __rest(_a, ["disabled"]);
    return (_jsx(MarvelToggle, Object.assign({ activeColor: "primary", inactiveColor: "slate6", "data-testid": props.testId, disabled: disabled, opacity: disabled ? 0.5 : 1 }, props)));
}
